import LoadingBox from 'components/Common/Loading/LoadingBox'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import { rem } from 'polished'
import styled from 'styled-components'

const SkeletonWrapper = styled.div`
  padding: ${rem(20)};
`

const FullWidthLoadingBox = styled(LoadingBox)`
  width: 100%;
`

interface Props {
  title?: string
}

function DrawerDetailLoadingSkeleton({ title }: Props) {
  return (
    <SkeletonWrapper>
      <Group direction="vertical" gap={16}>
        <FullWidthLoadingBox height={200} borderRadius="M" />
        {title ? (
          <Heading variant="heading3">{title}</Heading>
        ) : (
          <TextLoadingBox typography="heading3" width="60%" />
        )}
        <TextLoadingBox typography="body-medium" width="40%" />
        <TextLoadingBox typography="body-medium" width="100%" />
        <TextLoadingBox typography="body-medium" width="80%" />
      </Group>
    </SkeletonWrapper>
  )
}

export default DrawerDetailLoadingSkeleton
